import React, { Component } from 'react';
import styled from 'styled-components';
import { CardElement, injectStripe } from 'react-stripe-elements';

import WP from 'WP';
import api from 'api';
import { h1Styles } from 'partials/typography';

class PaymentForm extends Component{
	constructor(props){
		super(props);

		this.state = {
			complete: false,
			error: false,
			name: '',
		};

		this.submit = this.submit.bind(this);
	}

	async submit(ev){
		let response;

		try{
			let { token } = await this.props.stripe.createToken({name: this.state.name});
			response = await api.stripeSetCharge(token);
		} catch(e){
			console.log('error: ', e);
			this.setState({ error: true });
		} finally {
			if(response && response.status === 200) this.setState({ complete: true });
		}
	}

	handleKeyDown(key){
		if(key === 'Enter'){
			this.submit();
		}
	}

	render(){
		const options = WP.options;

		if (this.state.complete){
			return <h1>{options.success_message}</h1>;
		}

		if(this.state.error){
			return <h1>{options.error_message}</h1>;
		}

		return(
			<CheckoutWrapper onKeyDown={(e) => this.handleKeyDown(e.key) } className="checkout">
				<p>{options.checkout_title}</p>
				<CardElement hidePostalCode />
				<label>{options.name_label}</label>
				<input
					onChange={(e)=> this.setState({name: e.target.value})}
					name="name"
					type="text"
					placeholder={options.name_placeholder}
					required
				/>
				<button onClick={this.submit}>{options.payment_button_text}</button>
			 </CheckoutWrapper>
		);
	}
}

export default injectStripe(PaymentForm);

const CheckoutWrapper = styled.div`
	min-width: 400px;
	p {
		font-size: 18px;
		margin-bottom: 20px;
	}
	h1 {
	  ${h1Styles}
	  margin: 20px 0;
	  padding: 0;
	}
	label {
	  color: #6b7c93;
	  font-weight: 300;
	  letter-spacing: 0.025em;
	}
	.checkout {
      margin: 0 auto;
      max-width: 800px;
      box-sizing: border-box;
      padding: 0 5px;
    }
	button {
      white-space: nowrap;
      border: 0;
      outline: 0;
      display: inline-block;
      height: 40px;
      line-height: 40px;
      padding: 0 14px;
      box-shadow: 0 4px 6px rgba(50, 50, 93, .11), 0 1px 3px rgba(0, 0, 0, .08);
      color: #fff;
      border-radius: 4px;
      font-size: 15px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.025em;
      background-color: #6772e5;
      text-decoration: none;
      -webkit-transition: all 150ms ease;
      transition: all 150ms ease;
      margin-top: 10px;
    }
    form {
      margin-bottom: 40px;
      padding-bottom: 40px;
      border-bottom: 3px solid #e6ebf1;
    }
    button:hover {
      color: #fff;
      cursor: pointer;
      background-color: #7795f8;
      transform: translateY(-1px);
      box-shadow: 0 7px 14px rgba(50, 50, 93, .10), 0 3px 6px rgba(0, 0, 0, .08);
    }
    input,
    .StripeElement {
      display: block;
      margin: 10px 0 20px 0;
      width: 100%;
      padding: 10px 14px;
      font-size: 1em;
      box-shadow: rgba(50, 50, 93, 0.14902) 0px 1px 3px, rgba(0, 0, 0, 0.0196078) 0px 1px 0px;
      border: 0;
      outline: 0;
      border-radius: 4px;
      background: white;
    }
    input::placeholder {
      color: #aab7c4;
    }
    input:focus,
    .StripeElement--focus {
      box-shadow: rgba(50, 50, 93, 0.109804) 0px 4px 6px, rgba(0, 0, 0, 0.0784314) 0px 1px 3px;
      -webkit-transition: all 150ms ease;
      transition: all 150ms ease;
    }
    .StripeElement.IdealBankElement,
    .StripeElement.PaymentRequestButton {
      padding: 0;
    }
`


// WEBPACK FOOTER //
// ./src/partials/stripe/PaymentForm.js